import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { Identity } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Visit, SearchVisitor, SupplementaryEquipmentResponse, InhouseContact } from '../../tmc-visit.model';

@Injectable({
  providedIn: 'root'
})
export class PersonalVisitService {

  constructor(private tmcHttpService: HttpService) { }

  public loadPastVisits(identity: Identity): Observable<Visit> {
    return this.tmcHttpService.postWithContext<Visit>(environment.personalVisitEndpoint + '/pastVisits', identity);
  }

  public savePersonalVisit(personalVisit: Visit): Observable<any> {
    return this.tmcHttpService.postWithContext<any>(environment.personalVisitEndpoint + '/save', personalVisit);
  }

  public search(searchVisitor: SearchVisitor): Observable<any> {
    return this.tmcHttpService.postWithContext<any>(environment.personalVisitEndpoint + '/search', searchVisitor);
  }

  public getAvailableSupplementaryEquipments(identity: any): Observable<SupplementaryEquipmentResponse> {
    return this.tmcHttpService.postWithContext<SupplementaryEquipmentResponse>(environment.personalVisitEndpoint + '/supplementaryequipment',
      identity);
  }

  public loadContactDataForloggedInUser(): Observable<InhouseContact> {
    return this.tmcHttpService.postWithContext<any>(environment.personalVisitEndpoint + '/get-inhousecontact-currentuser', {});
  }

}
